import { UserEffects } from './user.effects';
import { EventsEffects } from './events.effects';
import {DevicesStatusEffects} from './devices-status.effects';
import {DevicesInfoEffects} from './devices-info.effects';
import {GroupEffects} from './group.effects';
import {UserModuleEffects} from './user-module.effects';
// import {EventMapEffects} from '../../my-features/event-map/effects/event-map.effects';
// import {HardwareFaultLevelEffects} from '../../my-features/hardware/effects/hardware-fault-level.effects';
// import {HardwareFaultCodeEffects} from '../../my-features/hardware/effects/hardware-fault-code.effects';

export const effects: any[] = [UserEffects, EventsEffects, DevicesStatusEffects, DevicesInfoEffects,
  GroupEffects, UserModuleEffects];
export * from './user.effects';
export * from './events.effects';
export * from './devices-status.effects';
export * from './devices-info.effects';
export * from './group.effects';
export * from './user-module.effects';
// export * from '../../my-features/event-map/effects/event-map.effects';
// export * from '../../my-features/hardware/effects/hardware-fault-level.effects';
// export * from '../../my-features/hardware/effects/hardware-fault-code.effects';


